import deDE from './snippet/de-DE.json';
import enGB from './snippet/en-GB.json';

Shopware.Component.register('riccardo-deal-list', () => import('./page/riccardo-deal-list'));
Shopware.Component.register('riccardo-deal-detail', () => import('./page/riccardo-deal-detail'));

Shopware.Module.register('riccardo-deal', {
    type: 'plugin',
    name: 'riccardo-deal',
    title: 'riccardo-deal.general.mainMenuItemGeneral',
    description: 'riccardo-deal.general.descriptionTextModule',
    color: '#E30613',
    icon: 'regular-tag',
    entity: 'riccardo_deal',

    snippets: {
        'de-DE': deDE,
        'en-GB': enGB,
    },

    routes: {
        list: {
            component: 'riccardo-deal-list',
            path: 'list',
        },
        detail: {
            component: 'riccardo-deal-detail',
            path: 'detail/:id',
            meta: { parentPath: 'riccardo.deal.list' },
            props: { default: (route) => ({ dealId: route.params.id }) },
        },
        create: {
            component: 'riccardo-deal-detail',
            path: 'create',
            meta: { parentPath: 'riccardo.deal.list' },
        },
    },

    navigation: [{
        id: 'riccardo-deal',
        label: 'riccardo-deal.general.mainMenuItemGeneral',
        color: '#E30613',
        path: 'riccardo.deal.list',
        icon: 'regular-tag',
        parent: 'sw-marketing',
        position: 100,
    }],
});
